module.exports = __webpack_public_path__ + "img/ionicons.a2c4a261.svg";